import React, { useEffect } from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import ColoradoRiverAccessSidebarChart from "./ColoradoRiverAcessSidebarChart";
import ColoradoRiverAccessLocationFilter from "../ColoradoRiverAccessLocationFilter";
import userActions from "../actions";
import { useHistory, useLocation } from "react-router";
// import { population } from "../constants";

// import { western_arizona_shapes_included } from "./colorado_river_access_constants";

function ColoradoRiverAccessChartTab() {
  const {
    city_selected,
    city_water_sources,
    entity_entitlements,
    is_tribe,
    cities,
    tribes,
    tribe_selected,
    entitlements_by_year,
    cities_water_use,
    entitlement_year,
    is_western,
    western_arizona_selected,
    western_arizona_entities,
    western_arizona_entitlements,
    scenario_selected,
    population,
    irrigation_districts,
  } = useSelector((state) => state.technical_view);
  const classes = useStyles();
  const history = useHistory()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dropdown = params.get('dropdown');
  const {
    setSelectedCity,
    setSelectedTribe,
    setIsCity,
    setIsTribe,
    setIsWesternEntity,
    loadEntityEntitlements,
    setSelectedWesternArizonaEntity,
    // loadTribeMetrics,
    loadCityWaterSources,
    setSelectedIrrigationDistrict,
  } = userActions();

  // const westernArizonaHasShape = (obj) => {
  //   return western_arizona_shapes_included.hasOwnProperty(obj.label);
  // };

  const cityTribe = cities
    .concat(tribes)
    // .concat(western_arizona_entities.filter(westernArizonaHasShape));
    .concat(western_arizona_entities);

  // const start_year = 2024;
  // const end_year = 2028;


  const loadEntityFunc = () => {
    if (is_tribe){
      loadEntityEntitlements(tribe_selected.tribe_id, scenario_selected.value);
    }
    else{
      loadEntityEntitlements(city_selected.city_id, scenario_selected.value);
    }
  }
  useEffect(loadEntityFunc,[scenario_selected])


  const handleUrlParams = () => {
    if(dropdown && (cities?.length && tribes?.length && western_arizona_entities?.length)) {
      let concatenatedEntities = [...cities, ...tribes, ...western_arizona_entities]
      var entityFound = concatenatedEntities.find((item) => item?.label?.toLowerCase() === (dropdown?.toLowerCase()));
      if(entityFound) {
        if(entityFound?.entity_type === 'Central') {
          setSelectedCity(entityFound)
          loadCityWaterSources(entityFound?.value)
          setIsTribe(false);
          setIsCity(true)
          setIsWesternEntity(false);
          loadEntityEntitlements(entityFound?.value, scenario_selected.value);
        } else if (entityFound?.entity_type === 'Tribe') {
          setSelectedTribe(entityFound);
          setIsTribe(true);
          setIsCity(false)
          setIsWesternEntity(false);
          loadEntityEntitlements(entityFound?.value, scenario_selected.value);
        } else {
          setSelectedWesternArizonaEntity(entityFound);
          setIsTribe(false);
          setIsCity(false)
          setIsWesternEntity(true);
        }
      }
    }
  }

  useEffect(handleUrlParams, [dropdown, cities, tribes, western_arizona_entities])

  const handleChange = (value) => {
    // if (value <= 41) {
    //   var cityFound = cityTribe.find((city) => city.value === value);
    //   setSelectedCity(cityFound);
    //   loadCityWaterSources(value);
    //   setIsTribe(false);
    //   setIsWesternEntity(false);
    //   loadEntityEntitlements(value, scenario_selected.value);
    // } else if (value <= 50) {
    //   var tribeFound = cityTribe.find((tribe) => tribe.value === value);
    //   setSelectedTribe(tribeFound);
    //   loadTribeMetrics(value);
    //   setIsTribe(true);
    //   setIsWesternEntity(false);
    //   loadEntityEntitlements(value, scenario_selected.value);
    // } else {
    //   var westernFound = cityTribe.find((entity) => entity.value === value);
    //   setSelectedWesternArizonaEntity(westernFound);
    //   setIsWesternEntity(true);
    //   setIsTribe(false);
    // }

    var entityFound = cityTribe.find((entity) => entity.value === value);
    if (entityFound.entity_type === "Central") {
      setSelectedCity(entityFound);
      loadCityWaterSources(value);
      setIsCity(true)
      setIsTribe(false);
      setIsWesternEntity(false);
      loadEntityEntitlements(value, scenario_selected.value);

      /** Go to the colorado river access chart tab and display the last city name selected on the dropdown */
      history.push({
        pathname: `/visualizations/map`,
        search:  "?" + new URLSearchParams({type: "cities", dropdown: entityFound?.label}).toString()
      });
    }
    else if (entityFound.entity_type === "Tribe") {
      setSelectedTribe(entityFound);
      // loadTribeMetrics(value);
      setIsTribe(true);
      setIsCity(false)
      setIsWesternEntity(false);
      loadEntityEntitlements(value, scenario_selected.value);

      /** Go to the colorado river access chart tab and display the last irrigation_district name selected on the dropdown */
      history.push({
        pathname: `/visualizations/map`,
        search:  "?" + new URLSearchParams({type: "tribe", dropdown: entityFound?.label}).toString()
      });
    }
    else {
      // Update Western Arizona Entity
      const checkIrrigationDistrict = irrigation_districts?.find((item) => item?.label === entityFound?.label)
      if(checkIrrigationDistrict) {
        setSelectedIrrigationDistrict(checkIrrigationDistrict); 
      }
      setSelectedWesternArizonaEntity(entityFound);
      setIsWesternEntity(true);
      setIsCity(false)
      setIsTribe(false);

      history.push({
        pathname: `/visualizations/map`,
        search:  "?" + new URLSearchParams({type: "irrigation_district", dropdown: entityFound?.label}).toString()
      });
    }
  };

  if (!is_tribe && !is_western ) {
    const chartDataWaterSources = [
      {
        name: "Agua Fria",
        y: Math.round(city_water_sources.percent_tap_agua_fria * 100),
        color: "#C33229",
      },
      {
        name: "Groundwater",
        y: Math.round(city_water_sources.percent_tap_groundwater * 100),
        color: "#FFB628",
      },
      {
        name: "Salt River & Verde",
        y: Math.round(city_water_sources.percent_tap_salt_and_verde * 100),
        color: "#6AA4DC",
      },
      {
        name: "Colorado River",
        y: Math.round(city_water_sources.percent_tap_colorado * 100),
        color: "#2352D0",
      },
    ];

    const chartDataWaterUse = [
      {
        name: "Aquifer Recharge",
        y: cities_water_use[city_selected.name]
          ? Math.round(
              cities_water_use[city_selected.name].percent_aquifer_recharge *
                100
            )
          : 0,
        color: "#FFB607",
      },
      {
        name: "Agriculture",
        y: cities_water_use[city_selected.name]
          ? Math.round(
              cities_water_use[city_selected.name].percent_agriculture * 100
            )
          : 0,
        color: "#E0A45D",
      },
      {
        name: "Turf",
        y: cities_water_use[city_selected.name]
          ? Math.round(cities_water_use[city_selected.name].percent_turf * 100)
          : 0,
        color: "#43B99E",
      },
      {
        name: "Exchange",
        y: cities_water_use[city_selected.name]
          ? Math.round(
              cities_water_use[city_selected.name].percent_exchange * 100
            )
          : 0,
        color: "#718CD4",
      },
      {
        name: "Tap Water",
        y: cities_water_use[city_selected.name]
          ? Math.round(
              cities_water_use[city_selected.name].percent_tap_water * 100
            )
          : 0,
        color: "#2352D0",
      },
    ];

    return (
      <>
        {/* 
          Note: Commenting this since title is replaced with a dropdown box
          Check https://asudev.jira.com/browse/CURVE-369 for more info
          <Typography
            variant="body2"
            component="div"
            className={classes.cityTitle}
          >
            {city_selected.name}
        </Typography> */}

        {/* Replaced title with dropdown */}
        <ColoradoRiverAccessLocationFilter
          location_options={cityTribe}
          handleChange={handleChange}
          city_id={city_selected.city_id}
          style={{ marginLeft: 26 }}
          autocomplete={true}
        />

        <br/>
        <ChartSidebarAccordion group_name={`Entity Summary`} accordion_name={'entity'} >
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
            Population Served
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue1}
          >
            {population!=null && city_selected.name in population ? population[city_selected.name].toLocaleString("en-US") + " people" : "Data coming soon"} 
          </Typography>
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
            Colorado water access
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue1}
          >
            {entity_entitlements[entitlement_year]
              ? Math.round(
                  entity_entitlements[entitlement_year].total_co_access
                ).toLocaleString("en-US")
              : 0}{" "}
            ac-ft
          </Typography>
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
            Access change from 2024
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue1}
          >
            {entitlements_by_year[city_selected.city_id]
              ? Math.round(
                  entitlements_by_year[city_selected.city_id].access_change_start
                ).toLocaleString("en-US")
              : "Xxx,xxx"}{" "}
            ac-ft (
            {entitlements_by_year[city_selected.city_id]
              ? Math.round(
                  entitlements_by_year[city_selected.city_id]
                    .percent_access_change_start
                )
              : "xx"}
            %)
          </Typography>
        </ChartSidebarAccordion>
        {
          Object.keys(city_water_sources)?.length !== 0?
          (
            <ChartSidebarAccordion group_name={`Tap Water Sources - 2020`} accordion_name={'tap_water_sources'}>
              <ColoradoRiverAccessSidebarChart chart_data={chartDataWaterSources} />
            </ChartSidebarAccordion>
          )
          : (
            <ChartSidebarAccordion group_name={`Tap Water Sources - 2020`} accordion_name={'tap_water_sources'}>
              <Typography
                variant="body2"
                component="div"
                className={classes.metricSubTitle}
              >
                Results coming soon
              </Typography>
            </ChartSidebarAccordion>
          )
        }

        {
          Object.keys(city_water_sources)?.length !== 0?
          (
            <ChartSidebarAccordion group_name={`${city_selected.name} Water Uses - 2020`} accordion_name={'water_uses'}>
              <ColoradoRiverAccessSidebarChart chart_data={chartDataWaterUse} />
            </ChartSidebarAccordion>
          )
          : (
            <ChartSidebarAccordion group_name={`${city_selected.name} Water Uses - 2020`} accordion_name={'water_uses'}>
              <Typography
                variant="body2"
                component="div"
                className={classes.metricSubTitle}
              >
                Results coming soon
              </Typography>
            </ChartSidebarAccordion>
          )
          
        }

        
      </>
    );
  } else if (!is_western && is_tribe) {
    var total_contract_entitlement = entity_entitlements[entitlement_year]
      ? entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .dcp_nia_contract_entitlement +
        entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .indian_priority_contract_entitlement +
        entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .mi_priority_contract_entitlement +
        entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .nia_priority_contract_entitlement +
        entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .p13_contract_entitlement +
        entity_entitlements[entitlement_year].indivisual_priority_entitlements
          .leases_exchanges
      : 0;
    return (
      <>
        {/* 
          Note: Commenting this since title is replaced with a dropdown box
          Check https://asudev.jira.com/browse/CURVE-369 for more info
          <Typography
            variant="body2"
            component="div"
            className={classes.cityTitle}
          >
            {tribe_selected.name}
          </Typography> 
        */}

        {/* Replaced title with dropdown */}
        <ColoradoRiverAccessLocationFilter
          location_options={cityTribe}
          handleChange={handleChange}
          city_id={tribe_selected.tribe_id}
          style={{ marginLeft: 26 }}
          autocomplete={true}
        />
        <br/>
        <ChartSidebarAccordion group_name={`Entity Summary`} accordion_name={'entity'} >
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Region
        </Typography>
        <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          Central Arizona
        </Typography>
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Colorado water access
        </Typography>
        <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          {entity_entitlements[entitlement_year]
            ? Math.round(
                entity_entitlements[entitlement_year].total_co_access
              ).toLocaleString("en-US")
            : 0}{" "}
          ac-ft
        </Typography>
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Access change from 2024  
        </Typography>

        <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          {entitlements_by_year[tribe_selected.tribe_id]
            ? Math.round(
                entitlements_by_year[tribe_selected.tribe_id].access_change_start
              ).toLocaleString("en-US")
            : "Xxx,xxx"}{" "}
          ac-ft (
          {entitlements_by_year[tribe_selected.tribe_id]
            ? Math.round(
                entitlements_by_year[tribe_selected.tribe_id]
                  .percent_access_change_start
              )
            : "xx"}
          %)
        </Typography>
        </ChartSidebarAccordion>
        <ChartSidebarAccordion group_name={`Access Balance`} accordion_name={'access_balance'}>
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle1}
          >
            Total contract entitlement:
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue2}
          >
            {total_contract_entitlement? Math.round(total_contract_entitlement).toLocaleString("en-US") : 0}{" "}
            ac-ft
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue2}
          >
            -
          </Typography>
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle1}
          >
            Exchanges and leases:
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue2}
          >
            {entity_entitlements[entitlement_year]
              ? Math.abs(
                  Math.round(
                    entity_entitlements[entitlement_year]
                      .indivisual_priority_entitlements.obligation
                  )
                ).toLocaleString("en-US")
              : 0}{" "}
            ac-ft
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue2}
          >
            =
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue2}
          >
            {entity_entitlements[entitlement_year]
              ? Math.round(
                  entity_entitlements[entitlement_year].total_co_access
                ).toLocaleString("en-US")
              : 0}{" "}
            ac-ft
          </Typography>
        </ChartSidebarAccordion>
      </>
    );
  } else {
    return (
      <>
        {/* 
          Note: Commenting this since title is replaced with a dropdown box
          Check https://asudev.jira.com/browse/CURVE-369 for more info
          <Typography
            variant="body2"
            component="div"
            className={classes.cityTitle}
          >
            {western_arizona_selected.name}
          </Typography>
        */}

        {/* Replaced title with dropdown */}
        <ColoradoRiverAccessLocationFilter
          location_options={cityTribe}
          handleChange={handleChange}
          city_id={western_arizona_selected.entity_id}
          style={{ marginLeft: 26 }}
          autocomplete={true}
        />

        {/* <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Region
        </Typography> */}
        {/* <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          Western Arizona
        </Typography> */}
        <br/>
        <ChartSidebarAccordion group_name={`Entity Summary`} accordion_name={'entity'} >
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Colorado water access
        </Typography>
        <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          {western_arizona_entitlements[entitlement_year] && western_arizona_selected.entity_id in western_arizona_entitlements[entitlement_year]
            ? Math.round(
                western_arizona_entitlements[entitlement_year][
                  western_arizona_selected.entity_id
                ]["total_supply"] 
              ).toLocaleString("en-US")+ " ac-ft"
            : "The " + western_arizona_selected.name + " does not have an entitlement to Colorado River water but may receive Colorado River water from partners who deliver it to the irrigation district’s groundwater savings facility"}
          
        </Typography>
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          Access change from 2024
        </Typography>
        <Typography
          variant="h6"
          component="div"
          className={classes.metricValue1}
        >
          {western_arizona_entitlements[entitlement_year] && western_arizona_selected.entity_id in western_arizona_entitlements[entitlement_year]
            ? Math.round(
                western_arizona_entitlements[entitlement_year][
                  western_arizona_selected.entity_id
                ]["access_change_start"]
              ).toLocaleString("en-US")+ " ac-ft"
            : "The " + western_arizona_selected.name + " does not have an entitlement to Colorado River water but may receive Colorado River water from partners who deliver it to the irrigation district’s groundwater savings facility"}
          
          {western_arizona_entitlements[entitlement_year] && western_arizona_selected.entity_id in western_arizona_entitlements[entitlement_year]
            ? " (" +Math.round(
                western_arizona_entitlements[entitlement_year][
                  western_arizona_selected.entity_id
                ]["percent_access_change_start"]
              ) + "%)" 
            : ""}
          
        </Typography>
        </ChartSidebarAccordion>
      </>
    );
  }
}

export default ColoradoRiverAccessChartTab;
